import styled from "styled-components";

import SEModal from "../../../../shared/components/SEModal";
import { smallScreen } from "../../../../shared/constants/screenSizes";

export const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 27px;
  top: 27px;
`;

export const Modal = styled(SEModal)`
  margin-top: 40px;
  width: 580px;

  @media screen and (max-width: ${smallScreen}px) {
    height: 100%;
    margin-top: 0;
    width: 100%;
  }
`;
